import { withTranslation } from '@wix/wix-i18n-config';

export default (Component) => withTranslation()(Component);
